module.exports = __webpack_public_path__ + "img/flor_4.fc648a0d.svg";